import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

// Who is the client Subcontracting for
export const ClientSubcontractedReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                clientSubcontracted:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.CLIENT_SUBCONTRACTED_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, clientSubcontracted: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_CLIENT_SUBCONTRACTED:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, clientSubcontracted: action.payload};

        case ActionTypes.CLIENT_SUBCONTRACTED_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        default:
            return state;
    }
};